import {
  CAT_GATED_HREF,
  catGatedDisabledLinkClassName,
  catGatedOpenLinkClassName,
  handleCatGatedAnchorOpen,
} from "pages/project/common/taskBase/list/catGatedAnchor";
import { MouseEvent, ReactNode } from "react";

interface Props {
  href: string;
  children: ReactNode;
  dataTest: string;
  dataDdActionName: string;
  /** When set, left/middle-click goes through the gate instead of navigating `href`. */
  onBeforeOpen?: (open: () => void) => void;
  /** Non-interactive while mandatory-instruction ack cannot decide (loading/error). */
  disabled?: boolean;
}

/**
 * Phrase / Translate5 (and similar) CAT project links: plain anchor, gated `#` + auxclick, or disabled span.
 */
export function CatGatedProjectLink({
  href,
  children,
  dataTest,
  dataDdActionName,
  onBeforeOpen,
  disabled,
}: Props) {
  const openUrl = () => window.open(href, "_blank", "noopener,noreferrer");

  const handleGatedOpen = (event: MouseEvent<HTMLAnchorElement>) => {
    handleCatGatedAnchorOpen(event, () => onBeforeOpen?.(openUrl));
  };

  if (disabled) {
    return (
      <span aria-disabled="true" data-test={dataTest} className={catGatedDisabledLinkClassName}>
        {children}
      </span>
    );
  }

  if (onBeforeOpen) {
    return (
      <a
        href={CAT_GATED_HREF}
        role="button"
        data-test={dataTest}
        data-dd-action-name={dataDdActionName}
        className={catGatedOpenLinkClassName}
        onClick={handleGatedOpen}
        onAuxClick={handleGatedOpen}
      >
        {children}
      </a>
    );
  }

  return (
    <a
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      data-test={dataTest}
      data-dd-action-name={dataDdActionName}
      className={catGatedOpenLinkClassName}
    >
      {children}
    </a>
  );
}
